import { render, staticRenderFns } from "./CreateRateDialog.vue?vue&type=template&id=242a71d9&scoped=true&lang=html&"
import script from "./CreateRateDialog.vue?vue&type=script&lang=js&"
export * from "./CreateRateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242a71d9",
  null
  
)

export default component.exports